"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var elmer_common_1 = require("elmer-common");
exports.defineContext = function (target, options) {
    var cOptions = {
        saveAttrKey: "contextStore"
    };
    elmer_common_1.StaticCommon.extend(cOptions, options);
    if (!elmer_common_1.StaticCommon.isEmpty(cOptions.contextData) && !elmer_common_1.StaticCommon.isEmpty(cOptions.saveAttrKey)) {
        // define context store to target
        var oldData = target[cOptions.saveAttrKey] || {};
        var defineData = cOptions.contextData;
        for (var key in defineData) {
            if (!oldData[key]) {
                elmer_common_1.StaticCommon.defineReadOnlyProperty(oldData, key, defineData[key]);
            }
            else {
                // tslint:disable-next-line: no-console
                console.error("Define context error, the property " + key + " was existing on target object.");
                break;
            }
        }
        if (!target[cOptions.saveAttrKey]) {
            elmer_common_1.StaticCommon.defineReadOnlyProperty(target, cOptions.saveAttrKey, oldData);
        }
        return oldData;
    }
    else {
        // tslint:disable-next-line: no-console
        console.error("saveAttrkey and contextData can not be undefined or null");
    }
};
